import createAPI from '../axios'

//工作量相关API

const teachingPlanSkillsTraining = {
    courseConfirm: {
        queryList: config => createAPI('/courseConfirmSkillsTraining/queryList', 'post', config),
        deptOption: config => createAPI('/courseConfirmSkillsTraining/deptOption', 'post', config),
        majorOption: config => createAPI('/courseConfirmSkillsTraining/majorOption', 'post', config),
        gradeOption: config => createAPI('/courseConfirmSkillsTraining/gradeOption', 'post', config),
        auditOption: config => createAPI('/courseConfirmSkillsTraining/auditOption', 'post', config),
        queryTeachingProgress: config => createAPI('/courseConfirmSkillsTraining/queryTeachingProgress', 'post', config),
        saveCourseConfirm: config => createAPI('/courseConfirmSkillsTraining/saveCourseConfirm', 'post', config),
        submitCourseConfirm: config => createAPI('/courseConfirmSkillsTraining/submitCourseConfirm', 'post', config),
        updateAuditState: config => createAPI('/courseConfirmSkillsTraining/updateAuditState', 'post', config),
        queryAuditFlow: config => createAPI('/courseConfirmSkillsTraining/queryAuditFlow', 'post', config),
        queryChangeTeachingProgress: config => createAPI('/courseConfirmSkillsTraining/queryChangeTeachingProgress', 'post', config),
        audit: config => createAPI('/courseConfirmSkillsTraining/audit', 'post', config),
        updateAuditState_jxjcbg: config => createAPI('/courseConfirmSkillsTraining/updateAuditState_jxjcbg', 'post', config),
        saveModCourseConfirm: config => createAPI('/courseConfirmSkillsTraining/saveModCourseConfirm', 'post', config),
        checkCurTime: config => createAPI('/courseConfirmSkillsTraining/checkCurTime', 'post', config),
    },
    teachingCoursePlan: {
        list: config => createAPI('/teachingCoursePlanSkillsTraining/list', 'post', config),
        queryTree: config => createAPI('/teachingCoursePlanSkillsTraining/queryTree', 'post', config),
        baseParam: config => createAPI('/teachingCoursePlanSkillsTraining/baseParam', 'post', config),
        classFixed: config => createAPI('/teachingCoursePlanSkillsTraining/classFixed', 'post', config),
        initOption: config => createAPI('/teachingCoursePlanSkillsTraining/initOption', 'post', config),
        courseOption: config => createAPI('/teachingCoursePlanSkillsTraining/courseOption', 'post', config),
        saveRec: config => createAPI('/teachingCoursePlanSkillsTraining/saveRec', 'post', config),
        checkDelSKJH: config => createAPI('/teachingCoursePlanSkillsTraining/checkDelSKJH', 'post', config),
        delRec: config => createAPI('/teachingCoursePlanSkillsTraining/delRec', 'post', config),
        submit: config => createAPI('/teachingCoursePlanSkillsTraining/submit', 'post', config),
        updateAuditState: config => createAPI('/teachingCoursePlanSkillsTraining/updateAuditState', 'post', config),
        gradeOption: config => createAPI('/teachingCoursePlanSkillsTraining/gradeOption', 'post', config),
        deptOption: config => createAPI('/teachingCoursePlanSkillsTraining/deptOption', 'post', config),
        majorOption: config => createAPI('/teachingCoursePlanSkillsTraining/majorOption', 'post', config),
        classOption: config => createAPI('/teachingCoursePlanSkillsTraining/classOption', 'post', config),
        siteOption: config => createAPI('/teachingCoursePlanSkillsTraining/siteOption', 'post', config),
        majorSearchOption: config => createAPI('/teachingCoursePlanSkillsTraining/majorSearchOption', 'post', config),
        classSearchOption: config => createAPI('/teachingCoursePlanSkillsTraining/classSearchOption', 'post', config),
        exportSkjh: config => createAPI('/teachingCoursePlanSkillsTraining/exportSkjh', 'post', config),
        importSkjh: config => createAPI('/teachingCoursePlanSkillsTraining/importSkjh', 'post', config),
        checkEditInfo: config => createAPI('/teachingCoursePlanSkillsTraining/checkEditInfo', 'post', config),
        courseOption_multi: config => createAPI('/teachingCoursePlanSkillsTraining/courseOption_multi', 'post', config),
        saveTeachingPlanSet: config => createAPI('/teachingCoursePlanSkillsTraining/saveTeachingPlanSet', 'post', config),
        autoArrange: config => createAPI('/teachingCoursePlanSkillsTraining/autoArrange', 'post', config),
        preCourse: config => createAPI('/teachingCoursePlanSkillsTraining/preCourse', 'post', config),
        exportTimeTable: config => createAPI('/teachingCoursePlanSkillsTraining/exportTimeTable', 'post', config),
    },
};


export default teachingPlanSkillsTraining;



// WEBPACK FOOTER //
// ./src/api/modules/teachingPlanSkillsTraining.js